let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fE86S")).then(() => parcelRequire('jg97Z'));